import { ProductComplementDetailInformationContainer } from "../";

export const ProductComplementDetailMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <ProductComplementDetailInformationContainer />
    </div>
  );
};
